import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { GetDeliveryPromiseOfferRankingRequest } from 'services';
import { ApplicationState } from 'state/store/configureStore';
import {API_ERROR_CODE, ASINType, BuyingOption, OfferComparison} from 'state/types';
import { DeliveryPromise, DeliveryPromiseOfferComparisonWithState } from 'state/types/delivery-promise';
import { getDeliveryPromiseOfferRankingByStateSaga } from './sagas';

export const FEATURE_NAME = `all-delivery-promise-time`;

const adaptor = createEntityAdapter<DeliveryPromiseOfferComparisonWithState>({
  selectId: (m) => m.stateCode,
});

const slice = createSlice({
  name: FEATURE_NAME,
  initialState: adaptor.getInitialState(),
  reducers: {
    addDeliveryPromiseWithState: adaptor.upsertOne
  },
  extraReducers: (builder) => {
    builder.addCase(getDeliveryPromiseOfferRankingByStateSaga.rejected, (state, action) => {
      const getDeliveryPromiseRequest = action.payload as GetDeliveryPromiseOfferRankingRequest;
      let errorResult = {
        stateCode: getDeliveryPromiseRequest.stateCode,
        error: API_ERROR_CODE.GENERAL_ERROR
      } as DeliveryPromiseOfferComparisonWithState
      adaptor.addOne(state, errorResult)
    });
},
});

export const { addDeliveryPromiseWithState } = slice.actions;

export const {
  selectById: selectDelieryPromiseOfferAdditionalInfoByState,
  selectAll: selectAllDeliveryPromiseOfferAdditionalInfoWithStates
} = adaptor.getSelectors<ApplicationState>(state => state.deliveryPromiseState);

export const selectDeliveryPromiseByAsin = (state: DeliveryPromiseOfferComparisonWithState, asin?: ASINType): DeliveryPromise | undefined => {
  return (state.variationDeliveryPromises ?? []).find(dp => dp.asin === asin);
}

export const selectSortedBuyingOptionsByAsin = (state: DeliveryPromiseOfferComparisonWithState, asin?: ASINType, preRankBuyingOptions?: BuyingOption[]): BuyingOption[] | undefined => {
  const product: OfferComparison | undefined = (state.variationSortedOffers ?? []).find(product => product.asin === asin);
  let indexMap = new Map();
  (product?.offers ?? []).map((offer, index) => indexMap.set(offer.merchantId, index));
  const result = [...(preRankBuyingOptions ? preRankBuyingOptions : [])].sort(function(a, b) {
    return indexMap.get(a.obfuscatedMerchantId) - indexMap.get(b.obfuscatedMerchantId)
  })
  return result;
}

export const deliveryPromiseReducer = slice.reducer;
